import { AlertTriangle } from 'lucide-react';

import { cn } from '@/nucleo/utilitarios';

interface DestructiveActionChipProps {
  /** Texto do chip. */
  label?: string;
  tone?: 'destructive' | 'warning';
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * Chip padronizado para sinalizar ação irreversível junto do título de um
 * diálogo — cor sempre por token semântico (CLAUDE.md, "Regras de
 * interface", item 2). Ícone `aria-hidden`, o texto é o nome acessível;
 * `role="status"` para o leitor de tela anunciar o aviso sem precisar de foco.
 */
export function DestructiveActionChip({
  label = 'Ação irreversível',
  tone = 'destructive',
  size = 'sm',
  className,
}: DestructiveActionChipProps) {
  const paleta =
    tone === 'destructive'
      ? 'border-destructive/30 bg-destructive/10 text-destructive'
      : 'border-warning/30 bg-warning/10 text-warning';

  return (
    <span
      role="status"
      className={cn(
        'inline-flex items-center gap-1 rounded-full border font-semibold uppercase tracking-wide',
        size === 'sm' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs',
        paleta,
        className,
      )}
    >
      <AlertTriangle className={size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5'} aria-hidden />
      {label}
    </span>
  );
}

export default DestructiveActionChip;
